import { ENV } from "@/config/env";

// 認証トークンと検証コード用の自前エンドポイント
export const AUTH_ISSUE_CODE = `${ENV.AUTH_API_ENDPOINT}/auth/issue-code`;
export const AUTH_EXCHANGE = `${ENV.AUTH_API_ENDPOINT}/auth/exchange`;
export const WHOAMI = `${ENV.AUTH_API_ENDPOINT}/auth/whoami`;
export const AUTH_REFRESH = `${ENV.AUTH_API_ENDPOINT}/auth/refresh`;
// PRODUCT_DEV-396 セキュリティ設定/パスキー関連
export const AUTH_ME = `${ENV.AUTH_API_ENDPOINT}/auth/me`;
export const AUTH_LOGIN_OPTIONS = `${ENV.AUTH_API_ENDPOINT}/auth/login-options`;
// PRODUCT_DEV-421 エイリアスログイン用
export const AUTH_RESOLVE_ALIAS = `${ENV.AUTH_API_ENDPOINT}/auth/resolve-alias`;
// PRODUCT_DEV-641 ログイン画面のテナントブランド（ロゴ）解決用
export const AUTH_TENANT_BRANDING = `${ENV.AUTH_API_ENDPOINT}/auth/tenant-branding`;
// PRODUCT_DEV-1238 メールの無い人のパスワード再発行（依頼・コード利用）。認証不要
export const AUTH_PASSWORD_REISSUE_REQUEST = `${ENV.AUTH_API_ENDPOINT}/auth/password-reissue/request`;
export const AUTH_PASSWORD_REISSUE_REDEEM = `${ENV.AUTH_API_ENDPOINT}/auth/password-reissue/redeem`;
